<div class="container">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h2 *ngIf="!queryParams.id">Abertura de Solicitação de Serviço</h2>
        <h2 *ngIf="queryParams.id">
          Solicitação de Serviço {{ queryParams.id }}
        </h2>
      </mat-card-title>
      <mat-card-subtitle *ngIf="!queryParams.id">
        <h4>Data/Hora Abertura: {{ now | date : "dd/MM/yyyy HH:mm" }}</h4>
        <h4>Solicitante: {{ userLogged.name }}</h4>
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div fxLayout.lt-md="column" *ngIf="queryParams.id">
        <mat-card-subtitle fxLayout="column">
          <div fxLayout="column">
            <div fxLayout="row">
              <div
                class="details__title"
                fxFlex="30"
                fxLayoutAlign="end"
                *ngIf="queryParams.id"
              >
                O.S.:
              </div>
              <div class="details__text">{{ loadedServiceRequest?.id }}</div>
            </div>

            <div fxLayout="row">
              <div
                class="details__title"
                fxFlex="30"
                fxLayoutAlign="end"
                *ngIf="queryParams.id"
              >
                Cliente:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.companyDescription }}
              </div>
            </div>

            <div fxLayout="row">
              <div
                class="details__title"
                fxFlex="30"
                fxLayoutAlign="end"
                *ngIf="queryParams.id"
              >
                Regional:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.regionalDescription }}
              </div>
            </div>

            <div fxLayout="row">
              <div
                class="details__title"
                fxFlex="30"
                fxLayoutAlign="end"
                *ngIf="queryParams.id"
              >
                Local:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.serviceLocalDescription }}
              </div>
            </div>

            <div fxLayout="row">
              <div
                class="details__title"
                fxFlex="30"
                fxLayoutAlign="end"
                *ngIf="queryParams.id"
              >
                Técnico:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.agentName }}
              </div>
            </div>

            <div fxLayout="row">
              <div class="details__title" fxFlex="30" fxLayoutAlign="end">
                Data/Hora Abertura:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.date | date : "shortDate" }}
                {{ loadedServiceRequest?.hour }}
              </div>
            </div>

            <div fxLayout="row">
              <div class="details__title" fxFlex="30" fxLayoutAlign="end">
                Detalhes:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.observation }}
              </div>
            </div>

            <div fxLayout="row" class="details__divider">
              <mat-divider></mat-divider>
            </div>

            <div fxLayout="row">
              <div class="details__title" fxFlex="30" fxLayoutAlign="end">
                Tempo Gasto:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.serviceTime }}
              </div>
            </div>

            <div fxLayout="row">
              <div
                class="details__title"
                fxFlex="30"
                fxLayoutAlign="end"
                fxLayout.lt-md="end"
              >
                Atividade Realizada:
              </div>
              <div class="details__text">
                {{ loadedServiceRequest?.performedService }}
              </div>
            </div>
          </div>
        </mat-card-subtitle>

        <div
          *ngIf="
            !loadedServiceRequest?.agentId &&
            this.userLogged.type !== globalConst.defaults.user.client
          "
        >
          <form [formGroup]="associateAgentForm" *ngIf="queryParams.id">
            <div fxLayout="row" fxLayout.lt-md="column">
              <mat-form-field
                appearance="outline"
                fxFlex="auto"
                fxFlex.lt-md="100"
              >
                <mat-label>Associar Técnico</mat-label>
                <mat-select
                  id="agentId"
                  name="agentId"
                  formControlName="agentId"
                >
                  <mat-option *ngFor="let agent of agents" [value]="agent.id">
                    {{ agent.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              fxLayout="row"
              fxLayout.lt-md="column"
              fxLayoutAlign="end center"
              class="btn__register__container"
            >
              <button
                mat-raised-button
                type="submit"
                class="btn__add"
                [disabled]="associateAgentForm.invalid"
                (click)="associateAgent()"
              >
                Associar Técnico
              </button>
            </div>
          </form>
        </div>

        <!-- <div *ngIf="attachmentsFile.length" class="attachment__container">
          <div fxLayout="row" fxLayoutAlign="start center" class="title__sub-title">
            <mat-icon class="icons__info">attachments</mat-icon>
            <div>Anexos</div>
          </div>

          <mat-accordion>
            <mat-expansion-panel class="attachment__box" *ngFor="let attachment of attachmentsFile">
              <mat-expansion-panel-header>
                <mat-panel-title class="weight__600">
                  {{ attachment?.name }}.{{ attachment?.extension}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div fxLayout="row">
                <img src={{attachment?.blob}} class="embeded__image">
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div> -->
      </div>

      <form [formGroup]="serviceRequestForm" *ngIf="!queryParams.id">
        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Cliente</mat-label>
            <input
              matInput
              [matAutocomplete]="company"
              formControlName="company"
              (keyup)="filterCompanyOptions($event.target.value)"
            />
            <mat-autocomplete
              #company="matAutocomplete"
              [displayWith]="displayDescription"
            >
              <mat-option
                *ngFor="let company of filteredCompanyOptions"
                [value]="company"
              >
                {{ company?.description }}
              </mat-option>
            </mat-autocomplete>
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('company').valid &&
                serviceRequestForm.get('company').touched
              "
              class="error__input"
            >
              {{ serviceRequestForm.get("company").errors | errorMessageFG }}
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Regional</mat-label>
            <input
              matInput
              [matAutocomplete]="regional"
              formControlName="regional"
              (keyup)="filterRegionalOptions($event.target.value)"
            />
            <mat-autocomplete
              #regional="matAutocomplete"
              [displayWith]="displayDescription"
            >
              <mat-option [value]="allOptions">{{
                allOptions.description
              }}</mat-option>
              <mat-option
                *ngFor="let regional of filteredRegionalOptions"
                [value]="regional"
              >
                {{ regional?.description }}
              </mat-option>
            </mat-autocomplete>
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('regional').valid &&
                serviceRequestForm.get('regional').touched
              "
              class="error__input"
            >
              {{ serviceRequestForm.get("regional").errors | errorMessageFG }}
            </mat-hint>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Localidade</mat-label>
            <input
              matInput
              [matAutocomplete]="serviceLocal"
              formControlName="serviceLocal"
              (keyup)="filterServiceLocalOptions($event.target.value)"
            />
            <mat-autocomplete
              #serviceLocal="matAutocomplete"
              [displayWith]="displayDescription"
            >
              <!-- <mat-option [value]="allOptions">{{ allOptions.description }}</mat-option> -->
              <mat-option
                *ngFor="let serviceLocal of filteredServiceLocalOptions"
                [value]="serviceLocal"
              >
                {{ serviceLocal?.description }}
              </mat-option>
            </mat-autocomplete>
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('serviceLocal').valid &&
                serviceRequestForm.get('serviceLocal').touched
              "
              class="error__input"
            >
              {{
                serviceRequestForm.get("serviceLocal").errors | errorMessageFG
              }}
            </mat-hint>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>Prioridade</mat-label>
            <mat-select formControlName="priority" change>
              <mat-option value="alta">Alta</mat-option>
              <mat-option value="media">Média</mat-option>
              <mat-option value="baixa">Baixa</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>Tipo Atendimento</mat-label>
            <input matInput type="text" formControlName="attendance_type" />
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('attendance_type').valid &&
                serviceRequestForm.get('attendance_type').touched
              "
              class="error__input"
            >
              {{
                serviceRequestForm.get("attendance_type").errors
                  | errorMessageFG
              }}
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>Linha de Atuação</mat-label>
            <input matInput type="text" formControlName="line" />
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('line').valid &&
                serviceRequestForm.get('line').touched
              "
              class="error__input"
            >
              {{ serviceRequestForm.get("line").errors | errorMessageFG }}
            </mat-hint>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>DDI Whatsapp</mat-label>
            <input
              matInput
              type="text"
              formControlName="whatsapp_ddi"
              maxlength="2"
            />
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('whatsapp_ddi').valid &&
                serviceRequestForm.get('whatsapp_ddi').touched
              "
              class="error__input"
            >
              {{
                serviceRequestForm.get("whatsapp_ddi").errors | errorMessageFG
              }}
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>DDD Whatsapp</mat-label>
            <input
              matInput
              type="text"
              formControlName="whatsapp_ddd"
              maxlength="3"
            />
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('whatsapp_ddd').valid &&
                serviceRequestForm.get('whatsapp_ddd').touched
              "
              class="error__input"
            >
              {{
                serviceRequestForm.get("whatsapp_ddd").errors | errorMessageFG
              }}
            </mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>Número Whatsapp</mat-label>
            <input
              matInput
              type="text"
              formControlName="whatsapp_number"
              maxlength="11"
            />
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('whatsapp_number').valid &&
                serviceRequestForm.get('whatsapp_number').touched
              "
              class="error__input"
            >
              {{
                serviceRequestForm.get("whatsapp_number").errors
                  | errorMessageFG
              }}
            </mat-hint>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>E-mail CC</mat-label>
            <input
              matInput
              type="text"
              formControlName="email_cc"
              maxlength="300"
            />
          </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="auto">
            <mat-label>Detalhes</mat-label>
            <textarea
              matInput
              placeholder="Detalhes"
              formControlName="observation"
              maxlength="2000"
            ></textarea>
            <mat-hint
              *ngIf="
                !serviceRequestForm.get('observation').valid &&
                serviceRequestForm.get('observation').touched
              "
              class="error__input"
            >
              {{
                serviceRequestForm.get("observation").errors | errorMessageFG
              }}
            </mat-hint>
          </mat-form-field>
          <div class="caracteres-length">
            <mat-hint
              fxFlex="100"
              fxLayoutAlign="end top"
              *ngIf="serviceRequestForm.get('observation').valid"
              >Caracteres restantes:
              {{
                maxCaracteres -
                  serviceRequestForm.get("observation").value.length
              }}
            </mat-hint>
          </div>
        </div>

        <!-- <div class="attachment__container" *ngIf="!queryParams.id">
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="space-between center"
            class="title__sub-title">
            <div fxLayout="row">
              <mat-icon class="icons__info">attachments</mat-icon>
              <div>Anexos (máximo de {{maxAttachment}} anexos)</div>
            </div>
            <div>
              <button type="button" mat-raised-button (click)="fileInput.click()" color="primary"
                [disabled]="attachmentsFile.length >= maxAttachment">
                <mat-icon class="icons__info attachment__button__icon">attachments</mat-icon>
              </button>
              <input hidden multiple #fileInput type="file" id="file" (change)="registerDocument($event)">
            </div>
          </div>

          <div *ngIf="!attachmentsFile.length" fxLayoutAlign="center center">
            <p>Nenhum anexo cadastrado</p>
          </div>

          <div *ngIf="attachmentsFile.length >= maxAttachment" fxLayoutAlign="center center">
            <p>A solicitação possui um limite máximo de {{ maxAttachment }} anexos</p>
          </div>

          <div *ngIf="attachmentsFile.length">
            <mat-accordion>
              <mat-expansion-panel class="attachment__box" *ngFor="let attachment of attachmentsFile">
                <mat-expansion-panel-header>
                  <mat-panel-title class="weight__600">
                    {{ attachment?.name }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div fxLayout="column">
                  <button mat-raised-button color="warn" (click)="deleteDocument(attachment?.name)"
                    class="attachment__button__delete__document">
                    Excluir Documento
                  </button>
                </div>
                <div fxLayout="row">
                  <img src={{attachment?.blob}} class="embeded__image">
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div> -->

        <div
          fxLayout="row"
          fxLayout.lt-md="column"
          fxLayoutAlign="end center"
          class="btn__register__container"
        >
          <button
            mat-raised-button
            type="submit"
            color="primary"
            *ngIf="!queryParams.id"
            (click)="onSubmit()"
          >
            Cadastrar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
